import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { params, shape, string, useDataModel } from '@thd-nucleus/data-sources';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { useHelmet, RedirectTag } from '@thd-nucleus/thd-helmet';
import { RedirectContext } from './RedirectContext';
import { isInvalidItemId, isInvalidCanonical, isPEPRedirect, isNotFound } from './rules/pip-redirect-rules';
import { handleErrors } from '../utils/redirector-utils';

const pipHandler = ({ data, error: err, props, queries }) => {

  let error = err;
  if (queries && queries.length && !err) {
    const productQuery = queries.find((query) => query.operationName === 'product');
    if (productQuery && productQuery.error) {
      error = productQuery.error;
    }
  }

  const invalidItemId = isInvalidItemId({ itemId: props.itemId });
  if (invalidItemId) {
    return new RedirectTag(invalidItemId, props.bypass);
  }

  const errors = handleErrors(error);
  if (errors) {
    return new RedirectTag(errors, props.bypass);
  }

  const notFound = isNotFound({ data });
  if (notFound) {
    return new RedirectTag(notFound, props.bypass);
  }

  const {
    disableCanonicalRedirect,
    disablePEPRedirect,
    disableCMMMCRedirect,
    pathWithQueryParams
  } = props;

  const [path, queryParams] = pathWithQueryParams.split('?');

  const invalidCanonical = isInvalidCanonical({ data, path, disableCanonicalRedirect });
  if (invalidCanonical) {
    return new RedirectTag(invalidCanonical, props.bypass);
  }

  const pepRedirect = isPEPRedirect({ data, disablePEPRedirect, disableCMMMCRedirect, path, queryParams });
  if (pepRedirect) {
    return new RedirectTag(pepRedirect, props.bypass);
  }
  return null;
};

export const PIPRedirector = (props) => {

  const {
    disablePEPRedirect,
    disableCanonicalRedirect,
    disableQuestionsRedirect,
    disableReviewsRedirect,
    disableCMMMCRedirect
  } = useLayoutGroupProps({ props });

  const { pathWithQueryParams, itemId, bypass, timeoutRecovery } = useContext(RedirectContext);

  const handlerProps = {
    pathWithQueryParams,
    disableCanonicalRedirect,
    disableCMMMCRedirect,
    disablePEPRedirect,
    disableQuestionsRedirect,
    disableReviewsRedirect,
    itemId,
    bypass
  };

  const opts = {
    variables: {
      itemId
    },
    skip: !itemId
  };
  const { data, error } = useDataModel('product', opts);

  useHelmet('pipRedirector', { data, error, props: handlerProps }, pipHandler, [itemId]);

  return null;
};

PIPRedirector.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  disablePEPRedirect: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  disableCanonicalRedirect: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  disableQuestionsRedirect: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  disableReviewsRedirect: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  disableCMMMCRedirect: PropTypes.bool,
};

PIPRedirector.defaultProps = {
  disablePEPRedirect: false,
  disableCanonicalRedirect: false,
  disableQuestionsRedirect: false,
  disableReviewsRedirect: false,
  disableCMMMCRedirect: false,
};

PIPRedirector.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      canonicalUrl: string()
    })
  })
};
